import {Injectable} from '@angular/core';
import {Http, RequestOptions, Response, Headers, ResponseContentType} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {UserModel} from '../models/user.model';
import {
    getHistoricalUserByIdUrl,
    getSearchedUserUrl,
    getSearchUserCollateUrl,
    getUpdateExternalUserUrl,
    getUserPhotoUrl
} from '../app.urls';
import {AppCommunicationService} from './app-communication.service';
import {Router} from '@angular/router';
import {AuthenticationService} from './authentication.service';


@Injectable()
export class UserService {

    checkUnauthorizedAccess(error) {
        if (error.status === 401) {
            this.router.navigate(['/login']);
            return Observable.throw('Unauthorized');
        }
        return Observable.throw('error');
    }

    constructor(
        private _http: Http,
        private router: Router,
        private _authenticationService: AuthenticationService
    ) {}

    getUserById(id: number): Observable<UserModel> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + AppCommunicationService.getCurrentUser().access_token);
        const requestOptions = new RequestOptions({headers: headers});

        if (this._authenticationService.checkUser()) {
            return this._http
                .post(getHistoricalUserByIdUrl(id), '', requestOptions)
                .map(res => {
                    return <UserModel> res.json();
                })
                .catch(e => {
                    return this.checkUnauthorizedAccess(e);
                });
        }
    }

    // getPhotoForUser(hash): Observable<Blob> {
    //     const headers = new Headers();
    //     headers.append('Authorization', 'Bearer ' + AppCommunicationService.getCurrentUser().access_token);
    //     const requestOptions = new RequestOptions({headers: headers, responseType: ResponseContentType.Blob});
    //
    //     if (this._authenticationService.checkUser()) {
    //         return this._http
    //             .get(getUserPhotoUrl(hash), requestOptions)
    //             .map((res: Response) => res.blob())
    //             .catch(e => {
    //                 return this.checkUnauthorizedAccess(e);
    //             });
    //     }
    // }

    getPhotoForUser(hash): Observable<Blob> {
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + AppCommunicationService.getCurrentUser().access_token);
        const requestOptions = new RequestOptions({headers: headers, responseType: ResponseContentType.Blob});

        if (this._authenticationService.checkUser()) {
            return this._http
                .get(getUserPhotoUrl(hash), requestOptions)
                .map((res: Response) => res.blob())
                .catch(e => {
                    return this.checkUnauthorizedAccess(e);
                });
        }
    }

    getSearched(user): Observable<any> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + AppCommunicationService.getCurrentUser().access_token);
        const requestOptions = new RequestOptions({headers: headers});

        if (this._authenticationService.checkUser()) {
            return this._http
                .post(getSearchedUserUrl(), user , requestOptions)
                .map(res => res.json())
                .catch(e => {
                    return this.checkUnauthorizedAccess(e);
                });
        }
    }

    searchUser(phrase: string): Observable<any> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + AppCommunicationService.getCurrentUser().access_token);
        const requestOptions = new RequestOptions({headers: headers});

        if (this._authenticationService.checkUser()) {
            return this._http
                .get(getSearchUserCollateUrl(phrase), requestOptions)
                .map(res => res.json())
                .catch(e => {
                    return this.checkUnauthorizedAccess(e);
                });
        }
    }

    updateExternalThesisUser(userData): Observable<any> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + AppCommunicationService.getCurrentUser().access_token);
        const requestOptions = new RequestOptions({headers: headers});

        if (this._authenticationService.checkUser()) {
            return this._http
                .put(getUpdateExternalUserUrl(userData.id), userData, requestOptions)
                .map(res => res.json())
                .catch(e => {
                    return this.checkUnauthorizedAccess(e);
                });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/services/user.service.ts